import React, { useEffect } from "react";
import "./PrivacyPolicyBottomSheet.css";

const PrivacyPolicyBottomSheet = ({ isOpen, onClose }) => {
  // Prevent scrolling on body when bottom sheet is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`pv-sheet-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`pv-sheet-bottom-sheet ${isOpen ? "show" : ""}`}>
        <div className="pv-sheet-header">
          <div className="pv-sheet-drag-handle" onClick={onClose}></div>
          <button className="pv-sheet-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="pv-sheet-content">
          <div className="pv-sheet-header-section">
            <h1 className="pv-sheet-title pv-sheet-font-heading">
              Privacy Policy
            </h1>
            <p className="pv-sheet-subtitle">
              Last updated: April 24, 2026
              <br />
              Your privacy matters to us. This Privacy Policy explains how Aaroh
              Food Ltd collects, uses, and protects your personal information
              when you shop with us online or in-store.
            </p>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">1. Information We Collect</h3>
            <p>
              We collect information that you provide directly to us when you
              use our services. This includes:
            </p>
            <ul>
              <li>
                <strong>Personal Details:</strong> Name, email address, phone
                number, and delivery address.
              </li>
              <li>
                <strong>Payment Information:</strong> Credit/debit card details
                and billing address (processed securely through our payment
                partners).
              </li>
              <li>
                <strong>Order & Account Information: </strong>Purchase history, preferences, saved addresses, and feedback you share with us. 
              </li>
            </ul>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">
              2. How We Use Your Information
            </h3>
            <p>
              We use the information to:
            </p>
            <ul>
              <li> Process and deliver your orders </li>
              <li>
                Communicate order updates or respond to your enquiries 
              </li>
              <li>
                Improving our platform, products, and services based on your
                usage patterns and feedback.
              </li>
              <li>
                Send newsletters and promotional updates (optional)
              </li>
            </ul>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">3. Sharing of Information</h3>
            <p>
              We do not sell your personal information. We may share your
              information only with:
            </p>
            <ul>
              <li>
                <strong>Service  partners :</strong>  (delivery, payment processing, analytics) 
              </li>
              <li>
                <strong>Legal  authorities:</strong> when required for safety or compliance .
              </li>
            </ul>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">4. Data Security</h3>
            <p>
              We use industry-standard measures to secure your data. 
However, no online system is 100% secure, and we cannot guarantee absolute protection. 
            </p>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">5. Your Rights</h3>
            <p>
              You have the right to access, update, or delete your personal
              information. You can manage your account settings or contact us
              directly to exercise these rights. You may also unsubscribe from
              our marketing communications at any time.
            </p>
          </div>

          <div className="pv-sheet-section">
            <h3 className="pv-sheet-font-heading">6. Contact Us</h3>
            <p>
              If you have any questions or concerns about this Privacy Policy or
              our data practices, please contact us at:
            </p>
            <p>
                          <strong>Email:</strong> 
                          aarohfood@gmail.com
              <br />
              <strong>Phone:</strong> +4401707269944 
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyBottomSheet;
